import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {
  AuthGuardService as AuthGuard
} from './public/auth-guard.service';
import { MembershipGuard } from './shared/membership/membership.guard';

const routes: Routes = [
  {
    path: 'careers',
    loadChildren: () => import('./careers/careers.module').then(m => m.CareersModule),
    canActivate: [MembershipGuard],
  },
  // {
  //   path: 'projects',
  //   loadChildren: () => import('./projects/projects.module').then(m => m.ProjectsModule),
  //   canActivate: [AuthGuard]
  // },
  {
    path: 'experiences',
    loadChildren: () => import('./initiatives/initiatives.module').then(m => m.InitiativesModule),
    canActivate: [MembershipGuard],
  },
  {
    path: 'contracts',
    loadChildren: () => import('./contracts/contracts.module').then(m => m.ContractsModule),
    canActivate: [MembershipGuard],
  },
  // {
  //   path: 'programs',
  //   loadChildren: () => import('./programs/programs.module').then(m => m.ProgramsModule),
  //   canActivate: [AuthGuard]
  // },
  {
    path: 'events',
    loadChildren: () => import('./events/events.module').then(m => m.EventsModule),
    canActivate: [MembershipGuard],
  },
  {
    path: 'forum',
    loadChildren: () => import('./forum/forum.module').then(m => m.ForumModule),
    canActivate: [MembershipGuard],
  },
  {
    path: 'requests',
    loadChildren: () => import('./opportunity/opportunity.module').then(m => m.OpportunityModule),
    canActivate: [MembershipGuard],
  },
  {
    path: 'projects',
    loadChildren: () => import('./projects/projects.module').then(m => m.ProjectsModule),
    canActivate: [MembershipGuard],
  },
  {
    path: 'community',
    loadChildren: () => import('./community/community.module').then(m => m.CommunityModule),
    canActivate: [MembershipGuard],
  },
  {
    path: 'insight',
    loadChildren: () => import('./insight/insight.module').then(m => m.InsightModule),
    canActivate: [MembershipGuard],
  },
  {
    path: 'profile',
    loadChildren: () => import('./profile/profile.module').then(m => m.ProfileModule),
    canActivate: [AuthGuard, MembershipGuard]
  },
  {
    path: 'feed',
    loadChildren: () => import('./feed/feed.module').then(m => m.FeedModule),
    canActivate: [AuthGuard, MembershipGuard]
  },
  {
    path: 'organisation',
    loadChildren: () => import('./organisation/organisation.module').then(m => m.OrganisationModule),
    canActivate: [MembershipGuard]
  },
  {
    path: '',
    loadChildren: () => import('./public/public.module').then(m => m.PublicModule)
  },
  { path: '', redirectTo: 'login', pathMatch: 'full' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
